import(/* webpackMode: "eager" */ "/app/components/ui/searchfilter.tsx");
import(/* webpackMode: "eager" */ "/app/components/ui/sidebar.tsx");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
import(/* webpackMode: "eager" */ "/app/src/app/(lyk-appp)/(sidebar)/auth-wrapper.tsx");
import(/* webpackMode: "eager" */ "/app/src/app/(lyk-appp)/(sidebar)/cookieWrapper.tsx");
import(/* webpackMode: "eager" */ "/app/src/app/(lyk-appp)/(sidebar)/loading-screen.tsx");
import(/* webpackMode: "eager" */ "/app/src/app/(lyk-appp)/(sidebar)/onboardingModal-wrapper.tsx");
import(/* webpackMode: "eager" */ "/app/src/app/(lyk-appp)/(sidebar)/sidebar-wrapper.tsx")